import React from 'react';
import { Box, Typography, Paper, Button, Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import PlayStoreBtn from '../../components/common/PlayStoreBtn';
import salesgrotopbar3 from '../../assets/images/salesgrotopbar3.png';

const AppDownload = () => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', bgcolor: '#f5f5f5' }}>
      {/* Logo Image - Above the card */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mb: 3,
          width: '100%',
        }}
      >
        <img src={salesgrotopbar3} alt="SalesGro Logo" style={{ maxWidth: '220px', width: '100%', height: 'auto', objectFit: 'contain' }} />
      </Box>

      {/* Content Card */}
      <Container maxWidth="sm">
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            borderRadius: 2,
            textAlign: 'center',
            backgroundColor: '#fff',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <Box 
            sx={{ 
              mb: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <Typography variant="h4" component="h1" fontWeight="bold" gutterBottom>
              Download SalesGro Agent App
            </Typography>
            
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Agent login is available through our mobile app only.
            </Typography>
            {/* Play Store Button */}
            <PlayStoreBtn />
          </Box>

          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            component={RouterLink}
            to="/auth/login"
            sx={{ 
              mt: 3,
              color: 'text.secondary',
              borderColor: 'text.secondary',
              '&:hover': {
                borderColor: 'text.primary',
                color: 'text.primary',
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            Back to Login
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default AppDownload;